<template>
	<ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
		@current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
		<template slot="filters">
			<el-form-item label="角色名称" prop="word">
				<el-input v-model="query.word" placeholder="请输入角色名称" clearable @keyup.enter.native="handleSearch" />
			</el-form-item>
		</template>
		<template slot="btns">
			<el-button icon="el-icon-plus" size="mini" type="primary" @click="handleAdd">
				新增角色
			</el-button>
		</template>
		<template slot="columns">
			<el-table-column label="角色名称" align="center" prop="name" />
			<el-table-column label="角色描述" align="center" prop="description" />
			<el-table-column label="创建时间" align="center" prop="createTime">
				<template slot-scope="{ row }">
					{{ formatDate(row.createTime) }}
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="200">
				<template slot-scope="{ row }">
					<el-link :underline="false" type="primary" @click="handleConfig(row)">
						权限配置
					</el-link>
					<el-link style="margin: 0 10px" :underline="false" type="primary" @click="handleEdit(row)">
						编辑
					</el-link>
					<el-link :underline="false" type="danger" @click="handleDel(row)">
						删除
					</el-link>
				</template>
			</el-table-column>
		</template>
	</ListPage>
</template>

<script>
import { page, del } from "@/api/permission/role";
import listMixin from '@/mixins/list';

export default {
	data() {
		return {
			// 查询参数
			query: {
				word: "",
			},
		};
	},
	mixins: [listMixin],
	methods: {
		search() {
			this.loading = true;
			const params = {
				...this.query,
			};
			page(params).then(({ code, data, message }) => {
				if (code == 200) {
					this.tableData = data.records;
					this.total = data.total;
				} else {
					this.$message.error(message);
				}
				this.loading = false;
			});
		},
		handleAdd() {
			this.$router.push("/permission/role/form");
		},
		handleEdit(row) {
			this.$router.push({ path: "/permission/role/form", query: { id: row.id } });
		},
		handleConfig(row) {
			this.$router.push({ path: "/permission/role/config", query: { id: row.id } });
		},
		handleDel(row) {
			this.$confirm("是否删除该角色?", "提示", {
				type: "warning",
			})
				.then(() => {
					del(row.id).then(({ code, message }) => {
						if (code == 200) {
							this.$message.success("删除成功");
							this.search();
						} else {
							this.$message.error(message);
						}
					});
				})
				.catch(() => { });
		},
	},
};
</script>